import React from "react";

export default function RiderPrivacyPolicy() {
  return (
    <div
      style={{
        backgroundColor: "#F8F9FA",
        padding: "100px 20px",
        fontFamily: "'Inter', sans-serif",
        color: "#1C1C1C",
        lineHeight: "1.8",
      }}
    >
      <h1
        style={{
          fontFamily: "'Poppins', sans-serif",
          fontSize: "3rem",
          background: "linear-gradient(90deg, #E63946, #FFC300)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "40px",
        }}
      >
        Rider Privacy Policy
      </h1>

      <div
        style={{
          backgroundColor: "#FFFFFF",
          padding: "30px",
          borderRadius: "15px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
          marginBottom: "30px",
        }}
      >
        <p>
          🛡 <strong>INRYDE Privacy Policy – Riders (Drivers)</strong><br />
          <br />
          <strong>Effective Date:</strong> <br />
          INRYDE respects and protects the personal and professional data of Riders using our platform.
          This policy explains how we collect, verify, store, and use driver data for safety,
          compliance, payouts, and service operations.
        </p>
      </div>

      {/* 1. Information We Collect */}
      <div
        style={{
          backgroundColor: "#FFFFFF",
          padding: "30px",
          borderRadius: "15px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
          marginBottom: "30px",
        }}
      >
        <h2
          style={{
            fontFamily: "'Poppins', sans-serif",
            color: "#E63946",
            paddingBottom: "10px",
            marginBottom: "20px",
          }}
        >
          1. Information We Collect
        </h2>
        <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
          <li>Personal identification (name, address, DOB, contact numbers)</li>
          <li>Professional driving details (DL number, DL type, expiry date)</li>
          <li>Vehicle information (RC, photographs, insurance, permit)</li>
          <li>Regulatory documents (police verification, pollution certificate, fitness certificate, transport badge)</li>
          <li>Bank & PAN details for payouts and tax compliance</li>
          <li>Emergency contacts for safety purposes</li>
          <li>
            Location data during working hours for service operations, navigation,
            and earnings calculations.
          </li>
        </ul>
      </div>

      {/* 2. How We Use Rider Data */}
      <div
        style={{
          backgroundColor: "#FFFFFF",
          padding: "30px",
          borderRadius: "15px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
          marginBottom: "30px",
        }}
      >
        <h2
          style={{
            fontFamily: "'Poppins', sans-serif",
            color: "#E63946",
            paddingBottom: "10px",
            marginBottom: "20px",
          }}
        >
          2. How We Use Rider Data
        </h2>
        <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
          <li>Verify your identity and eligibility to drive commercially</li>
          <li>Activate your INRYDE Rider account and provide ride leads</li>
          <li>Share necessary details (name, photo, masked number) with customers</li>
          <li>Process payments, incentives, and invoices</li>
          <li>Assist in accident or insurance claims where applicable</li>
          <li>Ensure compliance with transport rules and safety regulations</li>
          <li>Detect misconduct, fraud, document forgery, impersonation, or illegal activities</li>
          <li>
            Live GPS tracking enables accurate routes, pricing, emergency support,
            and fraud detection.
          </li>
        </ul>
      </div>

      {/* 3. Verification */}
      <div
        style={{
          backgroundColor: "#FFFFFF",
          padding: "30px",
          borderRadius: "15px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
          marginBottom: "30px",
        }}
      >
        <h2
          style={{
            fontFamily: "'Poppins', sans-serif",
            color: "#E63946",
            paddingBottom: "10px",
            marginBottom: "20px",
          }}
        >
          3. Verification & Compliance
        </h2>
        <p style={{ color: "#6C757D" }}>
          Submitted documents may be verified via:
        </p>
        <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
          <li>Government databases</li>
          <li>Third-party agencies</li>
          <li>Law enforcement authorities</li>
          <li>Insurance providers</li>
        </ul>
        <p style={{ color: "#6C757D" }}>
          Forgery, misrepresentation, or expired documents may result in immediate suspension,
          permanent deactivation, or legal action.
        </p>
      </div>

      {/* 4. Sharing */}
      <div
        style={{
          backgroundColor: "#FFFFFF",
          padding: "30px",
          borderRadius: "15px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
          marginBottom: "30px",
        }}
      >
        <h2
          style={{
            fontFamily: "'Poppins', sans-serif",
            color: "#E63946",
            paddingBottom: "10px",
            marginBottom: "20px",
          }}
        >
          4. Sharing of Rider Information
        </h2>
        <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
          <li>Name, photograph, rating, and masked mobile number</li>
          <li>Vehicle number and model</li>
          <li>Shared with regulators or insurers for legal, safety, or claims purposes</li>
        </ul>
        <p style={{ color: "#6C757D" }}>
          We do not sell driver data to advertisers or third parties.
        </p>
      </div>

      {/* 5. Financial Data */}
      <div
        style={{
          backgroundColor: "#FFFFFF",
          padding: "30px",
          borderRadius: "15px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
          marginBottom: "30px",
        }}
      >
        <h2
          style={{
            fontFamily: "'Poppins', sans-serif",
            color: "#E63946",
            paddingBottom: "10px",
            marginBottom: "20px",
          }}
        >
          5. Financial Data Protection
        </h2>
        <p style={{ color: "#6C757D" }}>
          Your bank and PAN details are used only for payouts, invoicing, tax compliance,
          and fraud prevention. All financial data is encrypted and shared only
          with regulated financial entities.
        </p>
      </div>

      {/* 6. Data Security */}
      <div
        style={{
          backgroundColor: "#FFFFFF",
          padding: "30px",
          borderRadius: "15px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
        }}
      >
        <h2
          style={{
            fontFamily: "'Poppins', sans-serif",
            color: "#E63946",
            paddingBottom: "10px",
            marginBottom: "20px",
          }}
        >
          6. Data Security Measures
        </h2>
        <p style={{ color: "#6C757D" }}>
          We maintain encryption, document masking, restricted access controls,
          regular audits, and fraud detection systems. However, no system is 100%
          secure, and by using INRYDE, you acknowledge digital risks.
        </p>
      </div>

      {/* 7. Rider Rights */}
      <div
        style={{
          backgroundColor: "#FFFFFF",
          padding: "30px",
          borderRadius: "15px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
          marginTop: "30px",
        }}
      >
        <h2
          style={{
            fontFamily: "'Poppins', sans-serif",
            color: "#E63946",
            paddingBottom: "10px",
            marginBottom: "20px",
          }}
        >
          7. Your Rights as a Rider
        </h2>
        <p style={{ color: "#6C757D" }}>
          You may request correction, access, deletion, or copies of stored data.  
          Some data must remain stored even after account closure as required by
          transport laws, safety investigations, and financial audits.
        </p>
      </div>

      {/* 8. Changes */}
      <div
        style={{
          backgroundColor: "#FFFFFF",
          padding: "30px",
          borderRadius: "15px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
          marginTop: "30px",
        }}
      >
        <h2
          style={{
            fontFamily: "'Poppins', sans-serif",
            color: "#E63946",
            paddingBottom: "10px",
            marginBottom: "20px",
          }}
        >
          8. Changes to this Policy
        </h2>
        <p style={{ color: "#6C757D" }}>
          INRYDE may update this policy based on regulatory changes or service improvements.
          Continued use indicates acceptance.
        </p>
      </div>

      {/* 9. Contact */}
      <div
        style={{
          backgroundColor: "#FFFFFF",
          padding: "30px",
          borderRadius: "15px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
          marginTop: "30px",
        }}
      >
        <h2
          style={{
            fontFamily: "'Poppins', sans-serif",
            color: "#E63946",
            paddingBottom: "10px",
            marginBottom: "20px",
          }}
        >
          9. Contact for Privacy Queries
        </h2>
        <p style={{ color: "#6C757D" }}>
          INRYDE Data Protection Cell<br />
          Email: <a href="mailto:support@inryde.in" style={{ color: "#E63946" }}>infoinryde@gmail.com</a><br />
          Office Address: 2nd floor, D.no 50-1-40 Near ASR Statue, Seethammadhara, Visakhapatnam - 530013<br />
          Phone Number: 9866398548
        </p>
      </div>
    </div>
  );
}
